import { getDocument } from 'pdfjs-dist'

import './pdfWorker'

const THUMBNAIL_MAX_WIDTH = 480

// Renders the first page of a PDF to a PNG data URL entirely in-memory in
// the browser via pdf.js — the caller must never persist or upload the raw
// `data` buffer; only the data URL this returns should be used for display.
export async function renderPdfThumbnail(data: ArrayBuffer): Promise<string> {
  const pdf = await getDocument({ data }).promise
  const page = await pdf.getPage(1)

  const unscaledViewport = page.getViewport({ scale: 1 })
  const scale = THUMBNAIL_MAX_WIDTH / unscaledViewport.width
  const viewport = page.getViewport({ scale })

  const canvas = document.createElement('canvas')
  canvas.width = viewport.width
  canvas.height = viewport.height

  const canvasContext = canvas.getContext('2d')
  if (!canvasContext) {
    throw new Error(
      'Could not get a 2D canvas context to render the PDF preview'
    )
  }

  await page.render({ canvasContext, viewport }).promise

  return canvas.toDataURL('image/png')
}
